import { render, staticRenderFns } from "./IMSortField.vue?vue&type=template&id=46aa4fbe&scoped=true&"
import script from "./IMSortField.vue?vue&type=script&lang=js&"
export * from "./IMSortField.vue?vue&type=script&lang=js&"
import style0 from "./IMSortField.vue?vue&type=style&index=0&id=46aa4fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa4fbe",
  null
  
)

export default component.exports